export default __webpack_public_path__ + "static/media/picture_audience.c4f0609a.png";